<template>
  <div id="app1">
    <el-container>
      <el-aside width="80px" class="sideBar">
        <div class="logo">
          <img src="@/assets/images/logo.png" />
        </div>
        <ul>
          <li v-for="item in menuList" :key="item.id" :class="isActive(item)?'active':''" @click="switchMenu(item)">
            <router-link :to="{ path: item.path }" v-if="!item.meta.hidden" active-class="">
              <!-- <i class="iconfont " :class="item.meta.icon" scale="20" width="15px" height="15px"></i> -->
              {{item.meta.title}}
            </router-link>
          </li>
        </ul>
        <div class="fixed">
          <el-popover
            placement="right"
            trigger="click">
            <div class="user-popover">
              <!-- <a href="javascript:;" @click="modify()">修改密码</a> -->
              <a href="javascript:;" @click="logout()">退出</a>
            </div>
            <p class="user" slot="reference" v-text="operator.admin_name" />
          </el-popover>
        </div>
      </el-aside>
      <el-aside width="80px" class="subSideBar" v-show="subSideBarShow">
        <sub-menu :sub-menu-list="subMenuList" :main-title="mainTitle" ></sub-menu>
      </el-aside>
      <el-main>
        <keep-alive :include="cachedComponents">
          <router-view />
        </keep-alive>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SubMenu from './subMenu'
import { RouteDefines } from '@/utils/defines'

export default {
  name: 'LayoutMenu',
  components: {
    SubMenu
  },
  data() {
    return {
      subSideBarShow: false,  // 子菜单显示状态
      mainMenuList: [],
      subMenuList: [],
      mainTitle: '',
      route: null,
      shopPopoverVisible: false
    }
  },
  methods: {
    isShowSubMenu(router) {
      const currentRoute = this.$route.meta.level > 2 ? this.$route.meta.root_name : this.$route.meta.parent_name
      if (currentRoute === router.name) {
        this.subSideBarShow = router.meta.hasSubMenu
        this.mainTitle = router.meta.title
        this.subMenuList = router.children
      }
    },
    switchMenu(router) {
      this.isShowSubMenu(router)
    },
    isActive(router) {
      this.isShowSubMenu(router);
      const currentRoute = this.$route.meta.level > 2 ? this.$route.meta.root_name : this.$route.meta.parent_name
      return currentRoute === router.name;
    },
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push({
          name: RouteDefines.ROUTER_NAME_LOGIN
        })
      }).catch(error => {
        console.log(error);
      })
    },
    modify() {
      this.$router.push({
        name: RouteDefines.ROUTER_NAME_PASSWORD_HOME
      })
    }
  },
  computed: {
    ...mapGetters({
      cachedComponents: 'getCachedComponents',
      operator: 'getOperator',
      menuList: 'getMenuPermissions'
    }),
    /**
     * 解决不同路由，使用相同组件的问题
     */
    key() {
      return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/menu.vue